import { type CollectionActionsProps } from "@firecms/core";
import type { Story } from "./stories";
import { CopyButton } from "../actions/CopyButton";

export const PublishStatus = {
  DRAFT: "DRAFT",
  READY_TO_PUBLISH: "READY_TO_PUBLISH",
  PUBLISHING: "PUBLISHING",
  PUBLISHED: "PUBLISHED",
  UNPUBLISHING: "UNPUBLISHING",
  UNPUBLISHED: "UNPUBLISHED",
} as const;

export type PublishStatus = (typeof PublishStatus)[keyof typeof PublishStatus];

export type PublishSettings = {
  status: PublishStatus;
  publishedAt?: Date;
};

export type DocumentWithPublishSettings = {
  disabled: boolean;
  publishSettings: PublishSettings;
};

export const CopyAction = ({
  selectionController,
  collection,
}: CollectionActionsProps<Story>) => {
  const buttons = [];

  buttons.push(
    <CopyButton
      collection={collection}
      selectionController={selectionController}
      label={"Copy to"}
      loadingLabel={"Copying to"}
    />
  );

  return buttons;
};
